import { gql, TypedDocumentNode } from '@apollo/client'
import type { BackgroundActivityNotification } from 'components/backgroundActivity/types/BackgroundActivityTypes'

export interface GetBackgroundActivityNotificationsData {
  getBackgroundActivityNotifications: {
    content: BackgroundActivityNotification[]
  }
}

export const GET_BACKGROUND_ACTIVITY_NOTIFICATIONS: TypedDocumentNode<GetBackgroundActivityNotificationsData> = gql`
  query getBackgroundActivityNotifications {
    getBackgroundActivityNotifications(page: 0, size: 50) {
      content {
        action: notificationAction
        archived
        category: notificationCategory
        createdAt
        description
        id
        notificationMessageList {
          comment
          notificationStatus
          title
          url
        }
        originatorId
        progressPercentage
        status: notificationStatus
        type
        visited
      }
    }
  }
`
